import React, { Component } from 'react'
import { TimelineEventRendererRegistry } from '../registries'

type Props = {
    event?: {
        __src?: string
    }
}

export default class Annotation extends Component<Props> {
    render() {
        const Annotation = TimelineEventRendererRegistry.getComponent(this.props.event)

        return <Annotation {...this.props} />
    }
}
